import {debounce} from "../functions";

document.addEventListener("DOMContentLoaded", function () {
    const faqList = document.querySelectorAll('.feed-faq');
    const searchInput = document.querySelector('.js-search-input');
    const categorySelect = document.querySelector('.js-category-select');

    if (faqList.length && searchInput) {
        const filterFaq = () => {
            const searchTerm = searchInput.value.trim().toLowerCase();
            const selectedCategory = categorySelect ? categorySelect.value : '';

            faqList.forEach(faq => {
                const title = faq.querySelector('.feed-faq__inset--header--button');
                const titleText = title ? title.innerText.toLowerCase() : '';

                const matchSearch = searchTerm === '' || titleText.includes(searchTerm);
                const matchCategory = !selectedCategory || faq.classList.contains(selectedCategory);

                if (matchSearch && matchCategory) {
                    faq.classList.remove('hidden');
                } else {
                    faq.classList.add('hidden');
                }
            });
        };

        const handleInput = debounce(filterFaq, 300);
        searchInput.addEventListener('input', handleInput);

        if (categorySelect) {
            categorySelect.addEventListener('change', filterFaq);
        }

        filterFaq();
    }
});


